import { BoxLeadDetailsInfoLayout } from "@modules/boxLead/components/boxLeadInfo/boxLeadDetailsInfoLayout"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { type SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorView } from "@/components/ui/layout/error/errorView"
import { Suspense } from "react"
import { LoadingSpinner } from "@/modules/ui/components/loading"

export const useBoxLeadDetailsSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToLeadDetailsInfo = (leadId: string, args: SidebarNavigatorParams) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxLeadDetailsInfoLayout leadId={leadId} />
          </Suspense>
        </ErrorBoundary>
      ),
      ...args,
    })
  }

  return {
    navigateToLeadDetailsInfo,
  }
}
